import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "inline-block min-w-full align-middle" }
const _hoisted_2 = { class: "overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg" }
const _hoisted_3 = { class: "min-w-full divide-y divide-gray-300" }
const _hoisted_4 = { class: "bg-gray-50" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
}, "DNS server", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
}, "TTL", -1)
const _hoisted_7 = {
  scope: "col",
  class: "px-3 py-3.5 text-center text-sm font-semibold text-gray-900"
}
const _hoisted_8 = { class: "divide-y divide-gray-200 bg-white" }
const _hoisted_9 = { class: "py-2 pl-4 pr-3 text-sm sm:pl-6" }
const _hoisted_10 = { class: "h-10 flex items-center" }
const _hoisted_11 = ["src", "alt", "title"]
const _hoisted_12 = { class: "ml-4" }
const _hoisted_13 = { class: "break-words font-medium text-gray-900" }
const _hoisted_14 = { class: "break-all text-gray-500" }
const _hoisted_15 = { class: "break-words px-3 py-2 text-sm text-gray-500" }
const _hoisted_16 = { class: "text-gray-900" }
const _hoisted_17 = { class: "whitespace-nowrap px-3 py-2 text-lg text-gray-500 font-medium text-center" }

import { computed, PropType } from 'vue';
import { CheckCircleIcon } from '@heroicons/vue/20/solid';
import Duration from '@/components/micro/DurationComponent.vue';

export interface PropagationServerListItem {
  firstLine: string;
  secondLine: string;
  ttl: number | null;
  // null = not yet checked; true = only one variant; string = multiple variants
  variant: string | true | null;
  iconSrc: string;
  iconAlt: string;
  iconShape: 'circle' | '4x3';
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PropagationServerList',
  props: {
  items: {
    type: Array as PropType<Array<PropagationServerListItem>>,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const hasVariants = computed(() => props.items.some((item) => item.variant !== true && item.variant !== null));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("table", _hoisted_3, [
          _createElementVNode("thead", _hoisted_4, [
            _createElementVNode("tr", null, [
              _hoisted_5,
              _hoisted_6,
              _createElementVNode("th", _hoisted_7, _toDisplayString(_unref(hasVariants) ? 'Variant' : 'Response'), 1)
            ])
          ]),
          _createElementVNode("tbody", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items, (item) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: item.firstLine
              }, [
                _createElementVNode("td", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", {
                      class: _normalizeClass([item.iconShape === 'circle' ? 'h-6 w-6 rounded-full' : 'h-[1.125rem] w-6', "flex-shrink-0"])
                    }, [
                      _createElementVNode("img", {
                        class: _normalizeClass(item.iconShape === 'circle' ? 'h-6 w-6 rounded-full' : 'h-[1.125rem] w-6'),
                        src: item.iconSrc,
                        alt: item.iconAlt,
                        title: item.iconAlt
                      }, null, 10, _hoisted_11)
                    ], 2),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, _toDisplayString(item.firstLine), 1),
                      _createElementVNode("div", _hoisted_14, _toDisplayString(item.secondLine), 1)
                    ])
                  ])
                ]),
                _createElementVNode("td", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    (item.ttl)
                      ? (_openBlock(), _createBlock(Duration, {
                          key: 0,
                          seconds: item.ttl
                        }, null, 8, ["seconds"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("td", _hoisted_17, [
                  (item.variant === true)
                    ? (_openBlock(), _createBlock(_unref(CheckCircleIcon), {
                        key: 0,
                        class: "h-6 w-6 text-green-500 mx-auto",
                        "aria-hidden": "true"
                      }))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(item.variant), 1)
                      ], 64))
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}
}

})